export default __webpack_public_path__ + "static/media/IconDesc_CopperIngot.256.f9ff75ee.png";